import { StyleSheet } from 'react-native'

export const travelHistoryViewStyles = StyleSheet.create({
	container: {
	
	},
	row: {
		width: '100%',
		flexDirection: 'row',
	},
	rowSpacing: {
		marginBottom: 8
	},
	columnIcon: {
		flex: 0,
		width: 50,
		justifyContent: 'center',
	},
	columnInput: {
		flex: 1,
	},
	icon: {
		position: 'absolute',
		bottom: -12
	}
})
